export default __webpack_public_path__ + "static/media/java.a7fa780a.svg";